import React, { useEffect } from 'react';
import SearchBar from '../searchBar/searchBar';
import { Link } from 'react-router5';
import {useTranslation} from "react-i18next";

const safeColor = (color) => {
  return color.replace(/[^a-zA-Z0-9()#]/g, "")
}

const LinkTags = ({ links }) => {
  return <span className="c-infos_links">
    {
      links
      .filter(l => l.type)
      .map(l => {
	const color = safeColor(l.poi_link_category.color);
	return <span style={{color: color, borderColor: color}}>{l.type}</span>
      })
    }
  </span>
}

function SetEntities({entity, getRoute}){
  // type will not be there w/ we are listing entities of themes (and not links)
  const {poi_entity, links} = entity;

  let contact_img;
  if(poi_entity.img === undefined || poi_entity.img === null){
    contact_img = <span className="c-contact_img-replace">{poi_entity.name[0].toUpperCase()}</span>
  }else{
    contact_img = <img alt="" className="c-contact_img" style={{width: "50px", height: "50px"}} src={poi_entity.img} />
  }

  const [route_name, route_params] = getRoute(poi_entity);

  return (
    <>
      <Link routeName={route_name} routeOptions={{reload: true}} routeParams={route_params}>
        <div className={`c-entities entities ${poi_entity.id}`}>
          {contact_img}
          <div className="c-infos">
            <p>{poi_entity.name}</p>
	    <LinkTags links={links} />
          </div>
        </div>
      </Link>
    </>
  )
}

function prepSearch(term) {
  return term.toUpperCase().replace('É','E');
}

function sortEntity(data){
  return data.sort(function(a,b){
    var nameA = prepSearch(a.poi_entity.name);
    var nameB = prepSearch(b.poi_entity.name);
    return nameA.localeCompare(nameB);
  });
}

function filterEntity(entities, search) {
  if (search === "") return entities;

  search = prepSearch(search);
  return entities.filter(c => {
    return prepSearch(c.poi_entity.name).includes(search);
  });
}

function groupLinksByEntity(links_forward, links_backward) {
  const entity_link = links_forward.concat(links_backward)
      .filter(c => c.link_target_type === "poi_entity");

  var by_entity_id = {}
  entity_link.forEach(link => {
    var d = by_entity_id[link.poi_entity.id];
    if (!d) {
      by_entity_id[link.poi_entity.id] = {
	poi_entity: link.poi_entity,
	links: [link]
      }
    } else {
      d.links.push(link);
    }
  })

  return Object.keys(by_entity_id).map(x => by_entity_id[x]);
}


function Entities({links_forward, links_backward, getRoute}){
  const { t } = useTranslation();
  const [search, setSearch] = React.useState("");

  const links_by_entity = groupLinksByEntity(links_forward, links_backward);
  const filtered_entities = filterEntity(links_by_entity, search);
  const entities_with_links = sortEntity(filtered_entities);


  if(links_by_entity.length === 0){
    return <p>{t('Aucun élément à afficher')}</p>
  }

  return <>
    <div className="c-container_search-bar">
      <SearchBar value={search} handleChange={(e) => setSearch(e.target.value)} />
    </div>
    {entities_with_links.map(e => {
      return(
	<div className="c-contact_list-letter title" key={e.poi_entity.id}>
	   <SetEntities entity={e} getRoute={getRoute} />
	</div>
      )
    })}
  </>
}

export default Entities
